module.exports = __webpack_public_path__ + "static/media/img15.a40a14fd.jpg";